export const USER_ACTIVITY_MODEL_MOBILE_SECURITY = 120;
export const USER_ACTIVITY_ACTION_FAILED_ACTIVATION_EMAILS = 146;
export const ACTIVATION_EMAIL_DIALOG_LEARN_MORE_URL =
  'https://www.bitdefender.com/business/support/en/77209-118218-manage-your-company.html';
export const EMAILS_CHANGE_EVENT = 'emailsChange';
